import React from "react";
import { Button } from "../ui/button";
import { Delete } from "lucide-react";

export const NumericKeyboard = ({ value, onChange, maxLength = 4 }) => {
  const handleKeyPress = (key) => {
    if (value.length < maxLength) {
      onChange(value + key);
    }
  };

  const handleDelete = () => {
    onChange(value.slice(0, -1));
  };

  const handleClear = () => {
    onChange("");
  };

  const keys = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["C", "0", "⌫"],
  ];

  return (
    <div className="grid grid-cols-3 gap-3 p-4 bg-secondary/30 rounded-xl" data-testid="numeric-keyboard">
      {keys.map((row, rowIndex) =>
        row.map((key) => (
          <Button
            key={`${rowIndex}-${key}`}
            variant={key === "C" || key === "⌫" ? "outline" : "secondary"}
            className="h-14 text-xl font-semibold"
            onClick={() => {
              if (key === "C") handleClear();
              else if (key === "⌫") handleDelete();
              else handleKeyPress(key);
            }}
            data-testid={`key-${key === "⌫" ? "delete" : key}`}
          >
            {key === "⌫" ? <Delete className="w-5 h-5" /> : key}
          </Button>
        ))
      )}
    </div>
  );
};
